import { Ingredient } from "src/api/client-api/ingredients/useGetOneIngredient";
import { ActivitiesFormData, ActivitiesFormIngredientSupplier } from "./Activities.type";
import { Campaign } from "src/api/client-api/useCampaign";
import { IngredientSupplierActivityDataWrite } from "src/api/client-api/ingredientSupplierActivityData/useUpsertIngredientSupplierActivityData";

export class ActivitiesService {
    static getIngredientToActivities = (
        existingIngredient: Ingredient | undefined,
        campaign: Campaign | null,
    ): ActivitiesFormData => {
        if (existingIngredient === undefined || campaign === null) {
            return { suppliers: [] };
        }

        const suppliers: ActivitiesFormIngredientSupplier[] =
            existingIngredient.suppliers?.map((supplier) => {
                const activityDatas =
                    supplier.ingredientSupplierActivityDatas?.filter(
                        (activityData) => activityData.campaign?.id === campaign.id,
                    ) ?? [];

                return {
                    ...supplier,
                    ingredientSupplierActivityDatas: activityDatas.map((activityData) => {
                        const quantity = activityData?.quantity;
                        const grossSales = activityData?.grossSales;

                        return {
                            ...activityData,
                            averagePrice: !quantity || quantity <= 0 ? 0 : (grossSales ?? 0) / quantity,
                        };
                    }),
                };
            }) ?? [];

        return { suppliers: suppliers };
    };

    public static getIngredientSupplierModifiedActivityDatas = (
        prevSuppliers: ActivitiesFormIngredientSupplier[],
        suppliers: ActivitiesFormIngredientSupplier[],
        campaign: Campaign,
    ): IngredientSupplierActivityDataWrite[] => {
        return suppliers.flatMap((supplier, i) => {
            const prevSupplier = prevSuppliers[i] ?? null;

            return (
                supplier.ingredientSupplierActivityDatas?.flatMap((activityData) => {
                    const prevActivityData = prevSupplier?.ingredientSupplierActivityDatas?.find(
                        (prevActivityData) => prevActivityData.id === activityData.id,
                    );

                    if (
                        prevActivityData &&
                        activityData.quantity === prevActivityData.quantity &&
                        activityData.grossSales === prevActivityData.grossSales
                    ) {
                        return [];
                    }

                    return [
                        {
                            id: activityData.id,
                            quantity: activityData.quantity,
                            grossSales: activityData.grossSales,
                            campaign: `/api/campaigns/${campaign.id}`,
                            ingredientSupplier: `/api/ingredient_suppliers/${supplier.id}`,
                        },
                    ];
                }) ?? []
            );
        });
    };
}
